export class HiddenStateStack {
  private stacks: Map<string, Set<string>[]> = new Map();
  private indexes: Map<string, number> = new Map();

  constructor() {
    // Initialize with common types
    this.stacks.set("all", [new Set()]);
    this.stacks.set("funktionar", [new Set()]); // changed from boardMember to match actual graph type
    this.stacks.set("address", [new Set()]);
    this.stacks.set("phoneNumber", [new Set()]); // Added for phone number graph type
    this.indexes.set("all", 0);
    this.indexes.set("funktionar", 0); // changed from boardMember to match actual graph type
    this.indexes.set("address", 0);
    this.indexes.set("phoneNumber", 0); // Added for phone number graph type
    
    // Also pre-initialize some common combinations
    this.stacks.set("address|funktionar", [new Set()]);
    this.stacks.set("address|phoneNumber", [new Set()]);
    this.stacks.set("funktionar|phoneNumber", [new Set()]);
    this.stacks.set("address|funktionar|phoneNumber", [new Set()]);
    this.indexes.set("address|funktionar", 0);
    this.indexes.set("address|phoneNumber", 0);
    this.indexes.set("funktionar|phoneNumber", 0);
    this.indexes.set("address|funktionar|phoneNumber", 0);
  }

  insertState(graphType: string, elementIds: Set<string>): void {
    // Initialize stack for this graph type if it doesn't exist
    if (!this.stacks.has(graphType)) {
      this.stacks.set(graphType, [new Set()]);
      this.indexes.set(graphType, 0);
    }
    
    const stack = this.stacks.get(graphType)!;
    const index = this.indexes.get(graphType)!;
    stack.splice(index + 1, 0, elementIds);
    this.indexes.set(graphType, index + 1);
  }

  getState(graphType: string): Set<string> {
    // If this graph type doesn't exist, initialize it first
    if (!this.stacks.has(graphType)) {
      console.log(`Initializing stack for new graph type: ${graphType}`);
      this.stacks.set(graphType, [new Set()]);
      this.indexes.set(graphType, 0);
    }
    
    const result = new Set<string>();
    const stack = this.stacks.get(graphType)!;
    const index = this.indexes.get(graphType)!;

    const states = stack.slice(0, index + 1);
    states.forEach((state) => {
      state.forEach((id) => result.add(id));
    });
    return result;
  }

  getStackLength(graphType: string): number {
    const stack = this.stacks.get(graphType)!;
    return stack.length;
  }

  goForward(graphType: string): void{
    const index = this.indexes.get(graphType)!;
    this.indexes.set(graphType, index + 1);
  }

  goBack(graphType: string): void {
    const index = this.indexes.get(graphType)!;
    this.indexes.set(graphType, index - 1);
  }

  atStartState(graphType: string): boolean {
    const index = this.indexes.get(graphType)!;
    return index === 0;
  }

  atEndState(graphType: string): boolean {
    const index = this.indexes.get(graphType)!;
    const stack = this.stacks.get(graphType)!;
    return index === stack.length - 1;
  }

  toJSON() {
    return {
      stacks: Object.fromEntries(
        Array.from(this.stacks.entries()).map(([key, value]) => [
          key,
          value.map(set => Array.from(set))
        ])
      ),
      indexes: Object.fromEntries(this.indexes)
    };
  }

  static fromJSON(data: any): HiddenStateStack {
    const instance = new HiddenStateStack();
    instance.stacks.clear();
    instance.indexes.clear();
    
    Object.entries(data.stacks).forEach(([key, value]: [string, any]) => {
      instance.stacks.set(key, value.map((arr: string[]) => new Set(arr)));
    });
    
    Object.entries(data.indexes).forEach(([key, value]: [string, any]) => {
      instance.indexes.set(key, value);
    });
    
    return instance;
  }
}